import { render, staticRenderFns } from "./AdminStudentRegistration.vue?vue&type=template&id=5b09c512"
import script from "./AdminStudentRegistration.vue?vue&type=script&lang=js"
export * from "./AdminStudentRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports